// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'

require('animate.css')
require('jquery-ui/themes/base/all.css')

Vue.prototype.$eventHub = new Vue() // Global event bus
Vue.use(Vuetify)
Vue.config.productionTip = false

Vue.prototype.$playSound = function (sound) {
  if (sound) {
    var audio = new Audio(sound)
    audio.play()
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js